document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initReviewScroll();
  initCarousels();
});

// En móvil: añade botones ‹ › (abajo a la derecha, estilo Apple) a los carruseles
// deslizables de pasos, beneficios y Cristal/Chapa. Avanza una tarjeta por clic,
// con bucle (de la última a la primera y viceversa). En escritorio no hacen nada.
function initCarousels() {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  var defs = [
    { scroller: '.mt-pasos__grid', card: '.mt-paso' },
    { scroller: '.mt-beneficios__grid', card: '.mt-beneficio' },
    { scroller: '.mt-meta-como__grid', card: '.mt-meta-como__item' } // números 01-04 de la ficha de anuncios
    // Cristal/Chapa (.mt-familias): sin flechas (solo deslizar con el dedo), a petición
  ];
  defs.forEach(function (def) {
    var sc = document.querySelector(def.scroller);
    if (!sc || sc.dataset.mtNav) return;
    sc.dataset.mtNav = '1';

    var nav = document.createElement('div');
    nav.className = 'mt-carousel-nav';
    nav.innerHTML =
      '<button class="mt-carousel-nav__btn" data-dir="prev" aria-label="Anterior" type="button">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>' +
      '<button class="mt-carousel-nav__btn" data-dir="next" aria-label="Siguiente" type="button">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>';
    sc.parentNode.insertBefore(nav, sc.nextSibling);

    function cards() {
      return Array.prototype.slice.call(sc.querySelectorAll(def.card));
    }
    // Índice de la tarjeta cuyo centro está más cerca del centro visible
    function currentIndex(list) {
      var mid = sc.getBoundingClientRect().left + sc.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }
    // Avanza/retrocede UNA tarjeta real (no un ancho fijo), centrándola.
    // Así llega a la última y hace bucle correctamente, sin saltarse ninguna.
    function go(dir) {
      var list = cards();
      if (!list.length) return;
      var i = currentIndex(list) + dir;
      if (i < 0) i = list.length - 1;        // del primero al último
      else if (i > list.length - 1) i = 0;   // del último al primero
      var scRect = sc.getBoundingClientRect();
      var tRect = list[i].getBoundingClientRect();
      var delta = (tRect.left + tRect.width / 2) - (scRect.left + sc.clientWidth / 2);
      var dest = sc.scrollLeft + delta;
      var max = sc.scrollWidth - sc.clientWidth;
      dest = Math.max(0, Math.min(dest, max));
      sc.scrollTo({ left: dest, behavior: 'smooth' });
    }
    var btns = nav.querySelectorAll('[data-dir]');
    for (var i = 0; i < btns.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          go(btn.getAttribute('data-dir') === 'next' ? 1 : -1);
        });
      })(btns[i]);
    }
  });
}

// En móvil: reseñas de una en una con flechas ‹ › (con bucle: de la última a la
// primera). En escritorio se mantiene la marquesina con animación CSS.
function initReviewScroll() {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  var marquee = document.querySelector('.mt-marquee');
  var track = marquee && marquee.querySelector('.mt-marquee__track');
  if (!marquee || !track) return;

  marquee.classList.add('mt-marquee--slider'); // una tarjeta visible + snap, sin animación

  var nav = document.querySelector('.mt-resenas__nav');
  if (!nav) return;

  function stepWidth() {
    var c = track.querySelector('.mt-resena');
    return c ? c.getBoundingClientRect().width : marquee.clientWidth;
  }
  function go(dir) {
    var w = stepWidth();
    var max = marquee.scrollWidth - marquee.clientWidth;
    var target = marquee.scrollLeft + dir * w;
    if (target > max + 2) target = 0;      // del último al primero
    else if (target < -2) target = max;    // del primero al último
    marquee.scrollTo({ left: target, behavior: 'smooth' });
  }

  var btns = nav.querySelectorAll('[data-dir]');
  for (var i = 0; i < btns.length; i++) {
    (function (btn) {
      btn.addEventListener('click', function () {
        go(btn.getAttribute('data-dir') === 'next' ? 1 : -1);
      });
    })(btns[i]);
  }
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
  // Red de seguridad: si por lo que sea el observer nunca dispara para algún
  // elemento (plantilla nueva sin scroll, fallo puntual, etc.), no se queda
  // invisible para siempre.
  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
  }, 1800);
}

function initCountUp() {
  var els = document.querySelectorAll('[data-mt-countup]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-mt-countup')) || 0;
        var suffix = el.getAttribute('data-mt-countup-suffix') || '';
        var duration = 1200;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(eased * target) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}
